const onlyNumber: RuleMethod = (rule, value, callback) => {
    if (value === '') return callback();
    const reg = /^[0-9]*$/;
    if (!reg.test(value as string)) {
        return callback(new Error(WordList.RuleCommonNumber));
    }
    return callback();
};

const onlyNumberAndNotEmpty: RuleMethod = (rule, value, callback) => {
    if (value === '') return callback(new Error(WordList.RuleCommonLabelEmpty2.format(WordList.TabelBillPostCode)));
    if (((value as string).replace(/\s*/g, '') === '') && value.toString()) {
        return callback(new Error(WordList.RuleLeastOneLetterOrNumber));
    }
    const reg = /^[0-9｜A-Z|a-z|\s]*$/;
    if (!reg.test(value as string)) {
        return callback(new Error(WordList.RuleLetterNumber));
    }
    return callback();
};

export default null;
export {
    onlyNumber,
    onlyNumberAndNotEmpty
};